import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnboxedModule } from '@fry/ui';
import { FryCommonModule } from '@fry/components/common';
import { MaterialModule } from '@fry/components/material';

import { WalkthroughsComponent } from './components/walkthroughs.component';
import { WalkthroughStepComponent } from './components/walkthrough-step.component';
import { WalkthroughActionsComponent } from './components/walkthrough-actions.component';

@NgModule({
  imports: [
    CommonModule,
    UnboxedModule,
    FryCommonModule,
    MaterialModule,
  ],
  declarations: [
    WalkthroughsComponent,
    WalkthroughStepComponent,
    WalkthroughActionsComponent,
  ],
  exports: [
    WalkthroughsComponent,
    WalkthroughStepComponent,
    WalkthroughActionsComponent,
  ],
  providers: [],
})
export class WalkthroughsModule {}
